import PillsNav from './pillsNav'

export default PillsNav
